module.exports = __webpack_public_path__ + "static/media/london-24.e9fb7c4a.svg";